import axios from 'axios';
import React, { useState } from 'react'
import './filterPage.css'

const baseURL = localStorage.getItem('baseURL')

function FilterPage({setIsLoggedIn}) {

    const [filters, setFilters] = useState({
        "bill_no": "28",
        "date": "16/10/2022",
        "place": "Buxar"
    })

    const handleDataUpdate = (e)=>{
        const val = e.target.value;
        const key = e.target.attributes['data-nam'].nodeValue;
        if (key == "place"){
            const temp = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
            setFilters((filters)=>({
                ...filters,
                [key] : val.replace('-', '/').replace('-', '/')
            }))
            return;
        }
        setFilters((filters)=>({
            ...filters,
            [key] : val.replace('-', '/').replace('-', '/')
        }))
    }

    const sendData = (e)=>{
        e.preventDefault();
        if (filters==null || filters==''){
            window.alert("Insert some data");
            return;
        }
        for (const key in filters){
            if (filters[key]==""){
                window.alert(`${key} is empty`);
                return;
            }
        }
        axios.post(baseURL+'/bt/filtered_transport_data', {filtered_transport_data: filters}, {headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('authToken')
        }}).then((response)=>{
            console.log(response)
            if (response.status!=200){
                console.log(response);
                window.alert('Error getting Data');
                setIsLoggedIn(false);
            } else {
                localStorage.setItem('billno', filters.bill_no);
                localStorage.setItem('date', filters.date);
                localStorage.setItem('place', filters.place);
                localStorage.setItem('csvData', JSON.stringify(response.data.data))
                const inputs = document.querySelectorAll('.filter form input');
                // inputs.forEach(item=>item.value='')
                inputs[0].focus();
                setFilters({
                    "bill_no": "28",
                    "date": "16/10/2022",
                    "place": "Buxar"
                });
                window.location.href = './preview';
            }
        }).catch(err=>{
            console.log(err);
            window.alert('Internal Error');
            setIsLoggedIn(false);
        })
    }

  return (
    <section class="filter">
        <div class="filter-left">
            <h1>You get what you desire</h1>
            <form onSubmit={sendData}>
                <div>
                    <label>Bill No.</label>
                    <input onChange={handleDataUpdate} data-nam="bill_no" type="text" placeholder='028' />
                </div>
                <div>
                    <label>Date</label>
                    <input onChange={handleDataUpdate} data-nam="date" type="text" placeholder='DD/MM/YY' />
                </div>
                <div>
                    <label>Place</label>
                    <input onChange={handleDataUpdate} data-nam="place" type="text" placeholder='Buxar' />
                </div>
                <button type="submit" class="primary-btn">Filter</button>
            </form>
        </div>
        <div class="filter-right">
        </div>
    </section>
  )
}

export default FilterPage